import { Button, Container, FormControl, InputLabel, MenuItem, Pagination, Select, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import DocumentItem from "../../components/DocumentItem";
import { Backend } from "../../services/Backend";
import { userHasPermissions } from "../../utils/utils";
import { UserPermissions } from "../../dto/Permissions";
import Loader from "../../components/Loader";

export default function SearchUrlPage() {
    const [isLoading, setIsLoading] = useState(true);

    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [foundDocuments, setFoundDocuments] = useState(0);
    const [searchQuery, setSearchQuery] = useState("");

    const [interest, setInterest] = useState("");
    const [language, setLanguage] = useState("");
    const [data, setData] = useState([]);

    const [showFilters, setShowFilters] = useState(false);

    const fetchDocuments = () => {
        const body = {
            interest,
            language,
            page: page - 1,
            title: searchQuery,
            sortBy: "rating_desc"
        };

        Backend.post(`url/search`, body)
            .then(res => {
                setData(res.data)
                setFoundDocuments(res.totalCount);
                setIsLoading(false);
                if (res.data.length > 0)
                    setTotalPages(Math.ceil(res.totalCount / res.data.length))
            });
    }

    useEffect(() => {
        fetchDocuments();

        userHasPermissions(UserPermissions.SearchWithCriteria)
            .then(res => setShowFilters(res));
    }, []);


    const handlePageChange = (e, newPage) => {
        setPage(newPage);
        
        const body = {
            interest,
            language,
            page: newPage - 1,
            title: searchQuery,
            sortBy: "rating_desc"
        };

        Backend.post(`url/search`, body)
            .then(res => {
                setData(res.data)
            });
    }

    const handleSearch = () => {
        fetchDocuments();
    }
    
    const resetFilters = () => {
        setInterest("");
        setLanguage("");

        Backend.get(`url?page=${page - 1}`)
            .then(res => {
                setData(res.data);
                setFoundDocuments(res.totalCount);
                if (res.data.length > 0)
                    setTotalPages(Math.ceil(res.totalCount / res.data.length))
            });
    }

    return <Container maxWidth="lg" className="my-5">
        
         <div className="flex gap-3">
            <TextField margin="normal" size="small" required fullWidth label="Search" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}  />
            <Button  variant="contained" sx={{ mt: 2, mb: 1 }} onClick={handleSearch}>Search</Button>
        </div>
        {showFilters ? <>
            <div className="flex gap-3  items-center">
            <FormControl size="small" sx={{ width: "200px"}} margin="normal">
                <InputLabel>Interest</InputLabel>
                <Select
                    label="Interest"
                    size="small"
                    margin="normal"
                    value={interest}
                    onChange={(e) => setInterest(e.target.value)}
                >
                    <MenuItem value="Transport safety">Transport safety</MenuItem>
                    <MenuItem value="Industrial safety">Industrial safety</MenuItem>
                    <MenuItem value="Chemical warehousing">Chemical warehousing</MenuItem>
                    <MenuItem value="Tank storage">Tank storage</MenuItem>
                </Select>
            </FormControl>
            <FormControl size="small" sx={{ width: "200px"}} margin="normal">
                <InputLabel>Language</InputLabel>
                <Select
                    label="Language"
                    size="small"
                    margin="normal"
                    value={language}
                    onChange={(e) => setLanguage(e.target.value)}
                >
                    <MenuItem value="English">English</MenuItem>
                    <MenuItem value="Dutch">Dutch</MenuItem>
                    <MenuItem value="German">German</MenuItem>
                    <MenuItem value="Spanish">Spanish</MenuItem>
                    <MenuItem value="French">French</MenuItem>
                    <MenuItem value="Chinese">Chinese</MenuItem>
                </Select>
            </FormControl>
        </div>
        <Button variant="contained" color="error" onClick={resetFilters}>Reset</Button>
        </> : ""}
        
        <p className="my-2">Found <b>{foundDocuments}</b> urls</p>
        <hr />
        {isLoading ? <div className="mx-auto w-fit mt-4"><Loader /></div>: <>
       
        <div className="mt-2">
            {data.map(item => <DocumentItem data={item} linkTo={`/url/${item.id}`}/>)}
        </div>
        <Pagination count={totalPages} color="primary"  page={page} onChange={handlePageChange} />
        </>}

    </Container>
}